var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTv = function SvgTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tv_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    x: 19.5,
    y: 2.5,
    stroke: "currentColor",
    rx: 1.5,
    transform: "rotate(90 19.5 2.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 1,
    x: 4,
    y: 16,
    fill: "currentColor",
    rx: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tv_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgTv;